// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","header__text":"Header_header__text__VVluW"};